import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";

export class BlackBg extends PIXI.Container implements StageLayer {

    private _blackBg: PIXI.Graphics;

    constructor() {
        super();
        this.name = "BlackBg";
        this.visible = false;
        this.init();
    }

    public show(alpha: number): void {
        this._blackBg.alpha = alpha;
        this._blackBg.visible = true;
        this.visible = true;
    }

    public showWithTimeline(alpha: number, duration: number): gsap.core.Timeline {
        this.visible = true;
        this._blackBg.visible = true;
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to(this._blackBg, {alpha: alpha, duration: duration});
        return tl;
    }

    public hide(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._blackBg, {
            duration: duration,
            alpha: 0
        });
        tl.add(() => {
            this.visible = false;
            this._blackBg.visible = false;
        });

        return tl;
    }

    private init(): void {
        this._blackBg = new PIXI.Graphics().beginFill(0x000000, 1).drawRect(-480, -480, 1680, 1680).endFill();
        this._blackBg.visible = false;
        this.addChild(this._blackBg);
    }
}